function doWhenElementsAvailable(elementSelectors, func, endlessObservation = false) {
  const observer = new MutationObserver(() => {
    const elementsAvailable = elementSelectors.every((selector) => document.querySelector(selector));
    if (elementsAvailable) {
      func();
      observer.disconnect();
      if (endlessObservation) doWhenElementsAvailable(elementSelectors, func, true);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

async function updateProductMain(productHandle, variantId) {
  const productMain = document.querySelector('.m-js-product-main');

  if (!productMain) return;

  let { rootUrl } = productMain.dataset;
  if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

  const { sectionId } = productMain.dataset;
  if (!sectionId) return;

  try {
    if (!variantId) {
      const spareParts = productMain.querySelector('.m-spare-parts');
      const fitsTo = productMain.querySelector('.js-m-fits-to');
      if (spareParts) {
        spareParts.innerHTML = '';
      }
      if (fitsTo) {
        fitsTo.innerHTML = '';
      }
      return;
    }
    const response = await fetch(`${rootUrl}products/${productHandle}/?section_id=${sectionId}&variant=${variantId}`);
    if (!response.ok) throw new Error(response.status);

    const responseText = await response.text();
    const tmpl = document.createElement('template');
    tmpl.innerHTML = responseText;

    const spareParts = productMain.querySelector('.m-spare-parts');
    const newSpareParts = tmpl.content.querySelector('.m-spare-parts');
    if (newSpareParts && newSpareParts.hasChildNodes() && spareParts) {
      spareParts.innerHTML = newSpareParts.innerHTML;
    } else if (spareParts) {
      spareParts.innerHTML = '';
    }

    const tmplFitsTo = document.createElement('template');
    tmplFitsTo.innerHTML = responseText;

    const fitsTo = productMain.querySelector('.js-m-fits-to');
    const newFitsTo = tmpl.content.querySelector('.js-m-fits-to');
    if (newFitsTo && newFitsTo.hasChildNodes() && fitsTo) {
      fitsTo.innerHTML = newFitsTo.innerHTML;
    } else if (fitsTo) {
      fitsTo.innerHTML = '';
    }

    const mediaGallery = productMain.querySelector('media-gallery');
    const newMediaGallery = tmpl.content.querySelector('media-gallery');
    if (
      newMediaGallery &&
      newMediaGallery.hasChildNodes() &&
      (mediaGallery.querySelector('#gallery-viewer').dataset.mediaReference == 'variant' ||
        newMediaGallery.querySelector('#gallery-viewer').dataset.mediaReference == 'variant')
    ) {
      mediaGallery.innerHTML = newMediaGallery.innerHTML;
      mediaGallery.init();
    }

    window.initLazyImages();
  } catch (error) {
    console.log(error);
  }
}

async function updateProductDetails(productHandle, variantId) {
  const productDetails = document.querySelector('.m-product-details');
  if (!productDetails) return;

  let { rootUrl } = productDetails.dataset;
  if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

  const { sectionId } = productDetails.dataset;
  if (!sectionId) return;

  try {
    const response = await fetch(`${rootUrl}products/${productHandle}/?section_id=${sectionId}&variant=${variantId}`);
    if (!response.ok) throw new Error(response.status);

    const tmpl = document.createElement('template');
    tmpl.innerHTML = await response.text();

    const el = tmpl.content.querySelector('.product-spec');
    if (el && el.hasChildNodes()) {
      document.querySelector('.m-product-details .product-spec').innerHTML = el.innerHTML;
    }
  } catch (error) {
    console.log(error);
  }
}

async function updateEnvironmentAssetsSlider(productHandle, variantId) {
  const productMain = document.querySelector('.m-js-product-main');
  const bannerMetafieldSlideshow = document.querySelector('.m-js-slideshow-use-metafields');
  const sectionId = bannerMetafieldSlideshow?.dataset.sectionId;

  if (!productMain && !bannerMetafieldSlideshow && !sectionId) return;

  let rootUrl = window.theme.routes.root;
  if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

  try {
    const response = await fetch(`${rootUrl}products/${productHandle}/?section_id=${sectionId}&variant=${variantId}`);
    if (!response.ok) throw new Error(response.status);

    const tmpl = document.createElement('template');
    tmpl.innerHTML = await response.text();

    const slideShowElement = bannerMetafieldSlideshow.querySelector('slide-show');
    const newSlideShowElement = tmpl.content.querySelector('slide-show');

    if (slideShowElement && newSlideShowElement) {
      slideShowElement.innerHTML = newSlideShowElement.innerHTML;
      slideShowElement.init();
    } else {
      const newSlideShowWrapper = tmpl.content.querySelector('.m-js-slideshow-use-metafields');
      bannerMetafieldSlideshow.innerHTML = newSlideShowWrapper.innerHTML;

      const newSlideShowElement = bannerMetafieldSlideshow.querySelector('slide-show');
      newSlideShowElement && newSlideShowElement.init();
    }
  } catch (error) {
    console.log(error);
  }
}

async function updateEnvironmentAssetsVideoSection(productHandle, variantId) {
  const productMain = document.querySelector('.m-js-product-main');
  const videoSection = document.querySelector('m-environment-video');
  const sectionId = videoSection?.dataset.sectionId;

  if (!productMain && !videoSection && !sectionId) return;

  let rootUrl = window.theme.routes.root;
  if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

  try {
    const response = await fetch(`${rootUrl}products/${productHandle}/?section_id=${sectionId}&variant=${variantId}`);
    if (!response.ok) throw new Error(response.status);

    const tmpl = document.createElement('template');
    tmpl.innerHTML = await response.text();

    const sectionElement = videoSection.querySelector('.section');
    const newVideoSectionElement = tmpl.content.querySelector('.section');

    if (sectionElement && newVideoSectionElement) {
      sectionElement.innerHTML = newVideoSectionElement.innerHTML;
      videoSection.init();
    } else {
      const newVideoSection = tmpl.content.querySelector('m-environment-video');

      videoSection.innerHTML = newVideoSection.innerHTML;
      videoSection.init();
    }
  } catch (error) {
    console.log(error);
  }
}

document.addEventListener('on:variant:change', async (event) => {
  const { product, variant, drawer } = event.detail;
  if (drawer) return;
  if (!variant || !product) return;

  if (variant?.id) {
    await updateProductMain(product.handle, variant.id);
    await updateProductDetails(product.handle, variant.id);
    await updateEnvironmentAssetsSlider(product.handle, variant.id);
    await updateEnvironmentAssetsVideoSection(product.handle, variant.id);
  } else {
    await updateProductMain(product.handle, null);
  }
});

async function showFormSuccessScreen() {
  const urlParams = new URLSearchParams(window.location.search);
  const formPostedSuccessfully = urlParams.get('customer_posted');

  if (formPostedSuccessfully == 'true' && window.location.hash.includes('_js_shopify_form')) {
    document.querySelector(`${window.location.hash} .text-success-text`)?.classList.remove('tw-hidden');
  }
}

function initContentReplacementOnWishlistPage() {
  const wishlistPageButton = `<a href="${window.theme.strings.emptyWishlistButtonLink}" role="button" class="btn btn--primary btn--lg btn--empty-wishlist">${window.theme.strings.emptyWishlistButtonText}</a>`;
  const emptyWishlistMessage = document.querySelector('.th-wl-no-wishlist h3');
  const emptyWishlistMessageConteiner = document.querySelector('.th-wl-no-wishlist');
  if (emptyWishlistMessage) {
    emptyWishlistMessageConteiner.innerHTML = `<h3>${emptyWishlistMessage.innerHTML}</h3>${wishlistPageButton}`;
  }
}

function instantHideWishlistCounter() {
  const wishlistCounter = document.querySelector('.th_wlc_product_count');
  wishlistCounter.style.display = 'none';
}

function initLiveChatCustomization() {
  const frame = document.getElementById('chat-widget-minimized');
  const frame_container = document.getElementById('chat-widget-container');

  const style = document.createElement('style');
  style.textContent =
    'body>div[role="main"]{padding:1.5em 0 0}body>div>div>div:last-child>[data-lc-id]{border-radius:0;width:50px;height:50px}';

  frame.parentNode.style.transition = 'margin .5s';
  frame.parentNode.style.zIndex = 39;
  frame.contentWindow?.document?.body?.parentNode.appendChild(style);

  frame_container.setAttribute('tabindex', '-1');
  frame_container.setAttribute('aria-hidden', 'true');
}

function handleCookieSettings() {
  const cookieScriptPopup = document.querySelector('.isense-reopen-widget-button');

  document.querySelector('[href*="#cookie-settings"]').addEventListener('click', (e) => {
    e.preventDefault();
    cookieScriptPopup.click();
  });
}

function updateAddToCartText() {
  const addToCartBtn = document.querySelector('.quick-add-drawer product-form button[type="submit"]');

  if (addToCartBtn) {
    if (addToCartBtn.parentElement.getAttribute('data-variant-available') === 'true') {
      addToCartBtn.innerHTML = addToCartBtn.getAttribute('data-add-to-cart-text') || 'Add to cart';
    } else {
      addToCartBtn.closest('.product-info__add-to-cart').classList.add('hidden');
    }
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  showFormSuccessScreen();

  if (window.location.href.includes('apps/wishlist')) {
    doWhenElementsAvailable(['.th-wl-no-wishlist'], initContentReplacementOnWishlistPage, true);
  }

  doWhenElementsAvailable(['.th_wlc_product_count'], instantHideWishlistCounter);
  doWhenElementsAvailable(['#chat-widget-minimized'], initLiveChatCustomization);
  doWhenElementsAvailable(['.isense-reopen-widget-button'], handleCookieSettings);
});

// VAS global functionality for manipulation of Print-items in cart/cart-drawer
document.addEventListener('on:line-item:change', async (event) => {
  const vasItemChange = event.detail.vasItemCartChange;
  const buttonCardDrawerForm =
    document.querySelector('button[form="cart-drawer-form"]') || document.querySelector('button[data-cart-checkout]');

  if (vasItemChange) {
    const cart = event.detail.cart;
    const changedItem = cart.items_added[0] || cart.items_removed[0];
    const changedItemKey = changedItem.view_key;
    const newQuantity = event.detail.newQuantity;
    const deleteItem = event.detail.deleteItem;
    const changedItemProperties = cart.items.find((item) => item.key === changedItemKey)?.properties;
    const customizationId = changedItemProperties?._customization_id;
    const cartPageSection = document.querySelector('.cc-main-cart');

    if (customizationId) {
      const printCombinationProduct = cart.items.find((item) => {
        return (
          item.properties['_vas_reference'] === customizationId && item.properties['_combination_product'] === 'true'
        );
      });

      if (printCombinationProduct) {
        const updates = {
          id: printCombinationProduct.key,
          quantity: newQuantity,
        };

        try {
          if (buttonCardDrawerForm) {
            buttonCardDrawerForm.disabled = true;
            document
              .querySelectorAll('.js-remove-item')
              .forEach((el) =>
                Object.assign(el.style, { pointerEvents: 'none', cursor: 'not-allowed', opacity: '0.6' }),
              );
          }
          const cartResponse = await fetch(`${window.theme.routes.cartChange}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          });

          if (!cartResponse.ok) {
            throw new Error(cartResponse.status);
          } else {
            if (cartPageSection) {
              const cartItemsElement = cartPageSection.querySelector('cart-items');
              cartItemsElement.refresh();
            } else {
              document.dispatchEvent(
                new CustomEvent('dispatch:cart-drawer:refresh', {
                  bubbles: true,
                }),
              );
            }
          }

          const cartData = await cartResponse.json();

          if (cartData) {
            const itemCount = cartData.item_count;
            const cartItemsElement = cartPageSection?.querySelector('cart-items');

            if (itemCount === 0) {
              const cartTitle = cartPageSection?.querySelector('.js-cart-title');
              const cartSummaryCss = document.getElementById('cart-summary-css');
              const cartSummary = document.getElementById('cart-summary');

              if (cartTitle) {
                cartTitle.classList.remove('text-start');
                cartTitle.classList.add('text-center');
              }

              if (cartSummaryCss) {
                cartSummaryCss.remove();
              }

              if (cartSummary) {
                cartSummary.hidden = true;
              }

              if (cartPageSection) {
                cartItemsElement.dataset.empty = true;
              }
            }

            document.dispatchEvent(new CustomEvent('dispatch:cart-print-items:check'));
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }
    } else if (deleteItem) {
      const customizationId = event.detail.customizationId;
      const printItems = event.detail.cart.items.filter((item) => {
        return item.properties['_vas_reference'] === customizationId;
      });

      if (customizationId && printItems.length) {
        const updates = printItems.reduce((accumulator, product) => {
          const key = product.key;
          accumulator[key] = 0;

          return accumulator;
        }, {});

        try {
          const cartResponse = await fetch(`${window.theme.routes.cartUpdate}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          });

          if (!cartResponse.ok) {
            throw new Error(cartResponse.status);
          } else {
            if (cartPageSection) {
              const cartItemsElement = cartPageSection.querySelector('cart-items');
              cartItemsElement.refresh();
            } else {
              document.dispatchEvent(
                new CustomEvent('dispatch:cart-drawer:refresh', {
                  bubbles: true,
                }),
              );
            }
          }

          const cartData = await cartResponse.json();

          if (cartData) {
            const itemCount = cartData.item_count;
            const cartItemsElement = cartPageSection?.querySelector('cart-items');

            if (itemCount === 0) {
              const cartTitle = cartPageSection?.querySelector('.js-cart-title');
              const cartSummaryCss = document.getElementById('cart-summary-css');
              const cartSummary = document.getElementById('cart-summary');

              if (cartTitle) {
                cartTitle.classList.remove('text-start');
                cartTitle.classList.add('text-center');
              }

              if (cartSummaryCss) {
                cartSummaryCss.remove();
              }

              if (cartSummary) {
                cartSummary.hidden = true;
              }

              if (cartItemsElement) {
                cartItemsElement.dataset.empty = true;
              }
            }

            document.dispatchEvent(new CustomEvent('dispatch:cart-print-items:check'));
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }
    }
  }
  if (buttonCardDrawerForm) {
    buttonCardDrawerForm.disabled = false;
    document
      .querySelectorAll('.js-remove-item')
      .forEach((el) => Object.assign(el.style, { pointerEvents: '', cursor: '', opacity: '' }));
  }
});

document.addEventListener('dispatch:cart-print-items:check', async () => {
  try {
    const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
    const cartData = await cartResponse.json();
    const vasProducts = cartData?.items.filter((item) => item.properties['_customization_id']);
    const correctPrintItems = cartData?.items.filter(
      (item) =>
        item.properties['_vas_reference'] &&
        vasProducts.some((product) => product.properties['_customization_id'] === item.properties['_vas_reference']),
    );
    const wrongPrintItems = cartData?.items.filter(
      (item) =>
        item.properties['_vas_reference'] &&
        !correctPrintItems.some(
          (printItem) => printItem.properties['_vas_reference'] === item.properties['_vas_reference'],
        ),
    );

    if (wrongPrintItems.length) {
      const updates = wrongPrintItems.reduce((accumulator, product) => {
        const key = product.key;
        accumulator[key] = 0;

        return accumulator;
      }, {});

      const cartResponse = await fetch(`${window.theme.routes.cartUpdate}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!cartResponse.ok) {
        throw new Error(cartResponse.status);
      } else {
        const cartPageSection = document.querySelector('.cc-main-cart');

        if (cartPageSection) {
          const cartItemsElement = cartPageSection.querySelector('cart-items');
          cartItemsElement.refresh();
        } else {
          document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:refresh', {
              bubbles: true,
            }),
          );
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
});

document.addEventListener('on:quickbuy:before-open', async () => {
  doWhenElementsAvailable(['.quick-add-drawer product-form button[type="submit"]'], updateAddToCartText);
});
